module.exports = __webpack_public_path__ + "media/images/icons/country_flags/vi-48bf3e009292c025067773e5f74ea640.svg";